/* eslint-disable class-methods-use-this */
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["flight"] }] */

import AssetsModel from '../models/assets';

export default class {
    constructor(booking) {
        this.booking = booking;
        this.confirmed = false;
    }

    availableForFlight(visitId, flight) {
        flight.updating = true;

        this.booking.$api.gms.reservation.findAvailableAssets(visitId, flight.id)
        .then((data) => {
            // Assets
            flight.availableAssets = data;
            if (!flight.assetData) {
                flight.assetData = AssetsModel.create();
            }

            flight.updating = false;
        })
        .catch((error) => {
            //
            flight.updating = false;
        });
    }

    hasAvailableForGroup(available, claimed, numberOfPlayers) {
        return available > 0 && claimed < numberOfPlayers;
    }

    availableForGroup(available, claimed, numberOfPlayers) {
        const median = numberOfPlayers - claimed;

        if (available > median) {
            return median;
        }

        return available;
    }

    claimAssetsForFlight(flight) {
        flight.updating = true;
        this.booking.$api.gms.reservation.claimAssets(this.booking.gms.visitId, flight.id, flight.assetData)
        .then((response) => {
            flight.updating = false;

            // Update availability of all groups.
            for (let index = 0; index < this.booking.gms.flights.length; index++) {
                const otherFlight = this.booking.gms.flights[index];
                this.availableForFlight(index);
            }
        })
        .catch((error) => {
            flight.updating = false;
        });
    }

    claimableInputForGroup(available, claimed, numberOfPlayers) {
        const input = available + claimed;

        if (input > numberOfPlayers) {
            return [...Array(numberOfPlayers + 1).keys()];
        }

        const asArray = [...Array(input + 1).keys()];
        return asArray;
    }

    onAddExtrasClicked(index) {
        this.booking.flights[index].opened = !this.booking.flights[index].opened;

        if (this.booking.flights[index].opened) {
            this.availableForFlight(index);
        }
    }

    onEditAssetsClick(flightIndex) {
        const flight = this.booking.flights[flightIndex];

        for (let index = 0; index < this.booking.flights.length; index++) {
            const otherFlight = this.booking.flights[index];

            if (otherFlight.id !== flight.id) {
                otherFlight.opened = false;
            }
        }

        flight.opened = true;
        this.availableForFlight(flightIndex);
        this.confirmed = false;
    }

    onAddGolfsetClicked(flight) {
        this.booking.$modals.$emit('show-modal:golfset', {
            sets: flight.availableAssets.availableGolfsets,
            flight,
            handler: this.onModalGolfsetConfirm.bind(this),
        });
    }

    onGolfsetRemoveClick(flight, set) {
        this.booking.$modals.$emit('show-modal:remove-golfset', this.removeGolfset.bind(this, flight, set));
    }

    removeGolfset(flight, set) {
        // Delete from uuids
        const index = _.findIndex(flight.assetData.golfsetUuids, ['uuid', set.uuid]);
        flight.assetData.golfsetUuids.splice(index, 1);

        // Delete from golfsets for client-side information
        const setIndex = _.findIndex(flight.assetData.golfsets, ['uuid', set.uuid]);
        flight.assetData.golfsets.splice(setIndex, 1);

        // Re-claim
        this.claimAssetsForFlight(flight);
    }

    onModalGolfsetConfirm(flight, set) {
        flight.assetData.golfsetUuids.push(set.uuid);
        flight.assetData.golfsets.push(set);
        this.claimAssetsForFlight(flight);
    }

    confirm() {
        this.confirmed = true;

        this.booking.$api.gms.reservation.findVisit(this.booking.gms.visitId)
        .then((response) => {
            this.booking.visit = response;
            window.raiseFacebookPageView();

            window.raiseGtmPageview('Step 7 - Booking Overview');
        });
    }
}
